import React, { useState, useEffect } from 'react';
import Sidebar from '../../layouts/Blogsidebar';
import { useParams } from 'react-router-dom';

function formatDate(date) {
    var month = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var d = new Date(date),
        name = '' + month[d.getMonth()],
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (day.length < 2)
        day = '0' + day;

    return [year, name, day].join(' ');
}

const OpenGraph = ({ title, description, image }) => (
    <>
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content={image} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="article" />
    </>
);

function Content() {
    const [blogDetails, setBlogDetails] = useState();
    let { slug } = useParams();

    useEffect(() => {
        (async () => {
            const response = await fetch(`https://petsgo.zimworx.site/wp-json/custom/v1/jw-single-blog/?slug=${slug}`);
            const data = await response.json();
            setBlogDetails(data);
        })();
    }, []);

    return (
        <>

            <OpenGraph
                title={blogDetails?.title}
                description={blogDetails?.excerpt}
                image={blogDetails?.featured_image}
            />

            <section className="blog-section section-gap-top">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="post-details-wrap">
                                <div className="post-thumb">
                                    <img src={blogDetails?.featured_image} alt="" />
                                </div>
                                <div className="post-meta">
                                    <ul>
                                        <li><i className="far fa-user" />J.W. Oliver</li>
                                        <li><i className="far fa-calendar-alt" /> {formatDate(blogDetails?.date_posted)}</li>
                                    </ul>
                                </div>
                                <div className="post-content">
                                    <h3 className="title">
                                        {blogDetails?.title}
                                    </h3>
                                    <div className='post-content' dangerouslySetInnerHTML={{ __html: blogDetails?.content }} />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-8">
                            <Sidebar />
                        </div>
                    </div>
                </div>
            </section>

        </>

    );
}

export default Content;
